var vm = new Vue({
    el : ".wrap"
    ,data:{
        tag_id : util.parse_query().tag_id || 180
        ,uid : util.parse_query().uid || 1202445
        ,info : {}
        ,count :0
        ,list:[]
        ,extinfo:"{}"
        ,user:{}
    }
    ,mounted:async function(){
        this.get_user()
        await this.get_wxconfig()
        await this.get_info();
        this.get_waterfull()
        this.set_share();
        this.set_extinfo()
    }
    ,methods:{
        get_info:async function(){
            var res = await axios({
                url : call.Info_Api_InfoTag
                ,params:{
                    ID : this.tag_id
                }
            })
            var data = res.data.data || {}
            var list = res.data.data.data || []
            var obj = res.data.data || {}
            this.info = list[0] || {}
            this.info.static = data.static
            this.count = obj.count || 0
        }
        ,get_user : async function(){
            var query = {
                UID: this.uid
            }
            var res = await axios({
                url : call.Comment_Api_User,
                params :query
            });
            if(res.data.data){
                this.user = res.data.data[0] || {};
            }
        }
        ,set_extinfo(){
            this.extinfo = JSON.stringify({
                Topic: this.tag_id
            })
        }
        ,get_wxconfig : async function(){
            var res = await axios({
                url : call.Comment_Api_WeixinTicket
                ,params : {
                    url : location.href
                }
            })
            var config = res.data.data || {}
            var wx_config = {
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: config.appid, // 必填，公众号的唯一标识
                timestamp: config.timestamp, // 必填，生成签名的时间戳
                nonceStr: config.noncestr, // 必填，生成签名的随机串
                signature: config.signature,// 必填，签名
                jsApiList: ["updateAppMessageShareData","updateTimelineShareData"], // 必填，需要使用的JS接口列表
                openTagList: ["wx-open-launch-app"] 
            }
            this.appid = config.appid
            console.log(wx_config)
            if(
                "wx" in window
            ){
                wx.config(wx_config)
            }
            
        }
        ,set_share: function(){
            var btn = document.getElementById('launch-btn');
            btn.addEventListener('error', function (e) {
                console.log('fail', e.detail);
                if(
                    util.is_android()
                ){
                    location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.imacco.mup004&fromcase=40002"
                }else if(
                    util.is_ios()
                ){
                    location.href = "https://itunes.apple.com/cn/app/meideni/id893109338?mt=8"
                }
            });
            if(
                !("wx" in window)
            ){
                return
            }
            var me = this
            wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                wx.updateAppMessageShareData({ 
                    title: me.info.Tag , // 分享标题
                    desc: me.info.Description, // 分享描述
                    link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: me.info.static, // 分享图标
                    success: function () {
                    }
                })
                wx.updateTimelineShareData({ 
                    title: me.info.Tag, // 分享标题
                    link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: me.info.static, // 分享图标
                    success: function () {
                    }
                })
            });
        }
        ,get_waterfull:async function(){
            var res = await axios({
                url :call.Info_Api_AppInfos
                ,params:{
                    CurrentPage:1
                    ,PageSize : 20
                    ,QualityTagID : this.tag_id
                    ,Version : 1
                }
            })
            this.list = res.data.data.Data || []
        }
        ,to_app(){
            if(
                util.is_wechat()
            ){
                return
            }
            var url = `scheme://macco/moduleNewTag?tagId=${this.tag_id}`
            location.href = url
        }
    }
})